module.exports = __webpack_public_path__ + "img/php.3e1c744b.png";